import { render } from "./day-three.vue?vue&type=template&id=16b61d86"
import script from "./day-three.vue?vue&type=script&lang=js"
export * from "./day-three.vue?vue&type=script&lang=js"

import "./day-three.vue?vue&type=style&index=0&id=16b61d86&lang=scss"
script.render = render

export default script